/*
  Change Password component - migrated from jwt-bch-frontend
*/

import React, { useState } from 'react'
import { Card, Form, Button, Alert } from 'react-bootstrap'
import { updateUser } from '../services/users'
import { getUser } from '../services/auth'
import NOTIFICATION from '../lib/notification'

const Notification = new NOTIFICATION()

function ChangePassword () {
  const [showForm, setShowForm] = useState(false)
  const [oldPassword, setOldPassword] = useState('')
  const [firstPassword, setFirstPassword] = useState('')
  const [, setSecondPassword] = useState('')
  const [step, setStep] = useState(1)
  const [message, setMessage] = useState('')

  const handleKeyDown = async (e) => {
    const value = e.target.value

    if (e.key === 'Escape') {
      resetState()
      return
    }

    if (e.key === 'Enter') {
      if (!value || value.length === 0) return

      switch (step) {
        case 1:
          setOldPassword(value)
          setStep(2)
          e.target.value = ''
          e.target.placeholder = 'Enter New Password'
          break

        case 2:
          setFirstPassword(value)
          setStep(3)
          e.target.value = ''
          e.target.placeholder = 'Repeat New Password'
          break

        case 3:
          setSecondPassword(value)
          if (value !== firstPassword) {
            Notification.notify('ERROR', 'Passwords do not match', 'danger')
            resetState()
            return
          }

          try {
            const userData = getUser()
            await updateUser({
              oldPassword,
              newPassword: firstPassword
            }, userData.jwt)

            Notification.notify('Success', 'Password changed successfully', 'success')
            resetState()
          } catch (err) {
            Notification.notify('Error', err.message, 'danger')
            setMessage(err.message)
            resetState()
          }
          break

        default:
          break
      }
    }
  }

  const resetState = () => {
    setShowForm(false)
    setOldPassword('')
    setFirstPassword('')
    setSecondPassword('')
    setStep(1)
    setMessage('')
  }

  const getPlaceholder = () => {
    switch (step) {
      case 1:
        return 'Enter Old Password'
      case 2:
        return 'Enter New Password'
      case 3:
        return 'Repeat New Password'
      default:
        return 'Enter Old Password'
    }
  }

  return (
    <Card>
      <Card.Body>
        <Card.Title>Change Password</Card.Title>
        {!showForm
          ? (
            <Button onClick={() => setShowForm(true)} variant='outline-primary'>
              Change Password
            </Button>
            )
          : (
            <div>
              <Form.Label><strong>{getPlaceholder()}</strong></Form.Label>
              <Form.Control
                id='input_password'
                name='change_password'
                type='password'
                placeholder={getPlaceholder()}
                onBlur={resetState}
                onKeyDown={handleKeyDown}
                autoFocus
              />
              {message && (
                <Alert variant='danger' className='mt-2'>{message}</Alert>
              )}
            </div>
            )}
      </Card.Body>
    </Card>
  )
}

export default ChangePassword
